import {categoryPage, searchPage} from "grandus-lib/utils/fetches";
import useSWR from "swr";
import { get, isArray, isEmpty, map } from "lodash";
import { Result, Row, Col, Divider, Layout } from "antd";
import {
  getSearchLinkAttributes,
  getSearchLinkAttributesFromRouter,
  paramsToPath,
} from "grandus-lib/hooks/useFilter";
import { FrownOutlined } from "@ant-design/icons";

import { useRouter } from "next/router";
import Listing from "components/product/listing/Listing";
import Search  from "components/header/Search";
import Menu  from "components/menu/Menu";

import Pagination from "components/pagination/Pagination";
import MetaData from "grandus-lib/components-atomic/MetaData";

import dayjs from "dayjs";
import {useTranslation} from "next-i18next";
import {fetchTranslations} from "utils/fetches";

const SearchResults = ({
  products,
  filter,
  meta,
  pagination
}) => {
  const router = useRouter();
  const { t } = useTranslation();
  let timeProducts = [];
  const start = get(router, "query.start", null);
  const end = get(router, "query.end", null);

  if(start && end){
    const { data, error } = useSWR(`/api/lib/v1/products?param=datum-konania/${start},${end}`, (url) =>
      fetch(url).then((r) => r.json()),
      {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
      }
    );
    timeProducts = get(data, "products", []);

  }

  return (
    <>
      <Menu />
      <Search />
      <br/>
      <div className="container">
        <MetaData {...meta} />
        {!isEmpty(timeProducts) ? (
          <>
            <h2>
              {t("Výsledky vo vybranom dátume {{start} - {{end}}", {
                start: dayjs(start).format("DD.MM.YYYY"),
                end: dayjs(end).format("DD.MM.YYYY")
              })}
            </h2>
            <Listing products={timeProducts} />
          </>
        ): ("")}

        <h1>{t("Hľadaný výraz: \"{{query}}\"", {query: get(router, "query.term")})}</h1>
        {isArray(products) && !isEmpty(products) ? (
          <>
            <Listing products={products} />
            <Pagination {...pagination} />
          </>
        ) : (
          <Result
            icon={<FrownOutlined />}
            title={t("Ľutujeme, nenašli sa produkty")}
            subTitle={t("Vášmu výberu nezodpovedajú žiadne produkty, zmeňte prosím kategóriu alebo kombináciu filtrov")}
          />
        )}
      </div>
    </>
  );
};

export async function getServerSideProps(context) {
  const props = await searchPage.serverSideProps(context);
  const {locale} = context;

  props.props = {
    ...props.props,
    ...(await fetchTranslations(locale)),
  }

  return props;
}

export default SearchResults;
